import {object, string, array, ref, boolean, number, mixed, date} from 'yup'
import * as CompanyEmailValidator from 'company-email-validator'
import {CONTACT_FORMAT_REGEX} from '../Constant/ConstantForWebsite'

const isValidUrl = (url: any) => {
  try {
    new URL(url)
  } catch (e) {
    return false
  }
  return true
}
export const MessageNotification = object().shape({
  messageRepliesEmail: string().when('messageRepliesEmail1', {
    is: true,
    then: string()
      .transform((value) => Array.from(new Set(value.split(';'))).join(';')) // dedupe - optional step
      .required()
      .test(
        'emails',
        'Wrong email address',
        (value: any) => value && value.split(';').every(isEmail)
      ),
  }),
  messageRepliesPhone: string().when('messageRepliesPhone1', {
    is: true,
    then: string().matches(
      /^(?:(61))?(?:\((?=.*\)))?(0?[4])?(\d\d(?:[-](?=\d{3})|(?!\d\d[-]?\d[-]))\d\d[-]?\d[-]?\d{3})$/,
      'Please enter valid number'
    ),
  }),
  reportEmail: string().when('reportEmail1', {
    is: true,
    then: string()
      .transform((value) => Array.from(new Set(value.split(';'))).join(';')) // dedupe - optional step
      .required()
      .test(
        'emails',
        'Invalid email address',
        (value: any) => value && value.split(';').every(isEmail)
      ),
  }),
  reportPhone: string().when('reportPhone1', {
    is: true,
    then: string().matches(
      /^(?:(61))?(?:\((?=.*\)))?(0?[4])?(\d\d(?:[-](?=\d{3})|(?!\d\d[-]?\d[-]))\d\d[-]?\d[-]?\d{3})$/,
      'Please enter valid number'
    ),
  }),
})

export const TemplatevalidationSchema = object().shape({
  name: string().required('Template Name is required'),
  message: string().required('Message is required'),
  type: string().required('Message Type is required'),

  // media: mixed().when('type', {
  //   is: (type: any, selectedgif: any) => type === 'MMS' && !selectedgif,
  //   then: mixed()
  //     .test('fileSize', 'Media upload size should be less than 248kb', (value) => {
  //       console.log(value, 'HHHHHHHHHHHHHH')

  //       if (value == undefined) return true // Media is required if type is MMS
  //       return false
  //     })
  //     .required('Media is required for MMS messages'),
  //   otherwise: mixed().notRequired(),
  // }),
  // Add more validation rules as needed
})
export const BulkMessageSchema = object().shape({
  name: string()
    .max(25, 'Input exceeds the maximum character length of 25')
    .required('Campaign name is required'),
  camp_type: string().required('Campaign type is require'),
  message: string().required('Message is required'),
  sender: string().required('Sender is required'),
  interval: string().when('staggerMessages', {
    is: true,
    then: string().required('interval is required'),
  }),
  quantity: string().when('staggerMessages', {
    is: true,
    then: string().required('interval is required'),
  }),
  to: object().shape({
    selectedType: string().required('select type is required'),
  }),
})

export const quickMessageSchema = object().shape({
  typeMsg: boolean(),
  sender: string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  alphaId: string().when('sender', {
    is: 'Alpha ID', // alternatively: (val) => val == true
    then: (schema) => schema.required(),
  }),
  Send_message: string().max(50, 'Maximum 50 symbols').required('Message is required'),
  contacts: array().min(1, 'Contacts is required').required('Contacts is required'),
  countryCode: string().max(50, 'Maximum 50 symbols').required('Password is required'),
})

export const resetPasswordValid = object().shape({
  password: string()
    .required('Password is required')
    .max(50, 'Must be less than 50 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
      'Minimum eight characters, at least one uppercase & lowercase letter, one number and one special character'
    ),
  confirmPassword: string()
    .oneOf([ref('password'), null], 'Passwords must match')
    .required('Confirm Password is required'),
})

export const UserAccountSchema = object().shape({
  email: string().email('Wrong email format').required('Email is required'),
  mobile: string().matches(
    /^(?:(61))?(?:\((?=.*\)))?(0?[4])?(\d\d(?:[-](?=\d{3})|(?!\d\d[-]?\d[-]))\d\d[-]?\d[-]?\d{3})$/,
    'Please enter valid number'
  ),
  // .required('Mobile number is required')
  name: string()
    .max(25, 'Input exceeds the maximum character length of 25')
    .required('Full name is required')
    .trim('The contact name cannot include leading and trailing spaces'),

  password: string().when('editting', {
    is: false,
    then: string()
      .min(8, 'Must be at least 8 characters')
      .max(50, 'Must be less than 50 characters')
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
        'Minimum eight characters, at least one uppercase & lowercase letter, one number and one special character'
      )
      .required('Password is required'),
  }),
  role: string().required('Role is required'),
  companyName: string()
    .max(50, 'Input exceeds the maximum character length of 50')
    .required('Company name is required')
    .trim('The contact name cannot include leading and trailing spaces'),
  industry: string().required('Industry is required'),
})

export const AdminDedicatedNumber = object().shape({
  audNumber: string()
    .matches(
      /^(?:(61))?(?:\((?=.*\)))?(0?[4])?(\d\d(?:[-](?=\d{3})|(?!\d\d[-]?\d[-]))\d\d[-]?\d[-]?\d{3})$/,
      'Please enter valid number'
    )
    .required('Mobile Number is required'),
  gateway: string().required('Gateway is required'),
  country: string().required('Country is required'),
  type: string().required('Type is required'),
})
export const EditAdminDedicatedNumber = object().shape({
  audNumber: string()
    .matches(
      /^(?:(61))?(?:\((?=.*\)))?(0?[4])?(\d\d(?:[-](?=\d{3})|(?!\d\d[-]?\d[-]))\d\d[-]?\d[-]?\d{3})$/,
      'Please enter valid number'
    )
    .required('Mobile Number is required'),
  gateway: string().required('Gateway is required'),
  country: string().required('Country is required'),
})

export const StaffAccountSchema = object().shape({
  email: string().email('Wrong email format').required('Email is required'),
  mobile: string()
    .matches(
      /^(?:(61))?(?:\((?=.*\)))?(0?[4])?(\d\d(?:[-](?=\d{3})|(?!\d\d[-]?\d[-]))\d\d[-]?\d[-]?\d{3})$/,
      'Please enter valid number'
    )
    .required('Mobile number is required'),
  name: string()
    .max(25, 'Input exceeds the maximum character length of 25')
    .required('Full name is required')
    ?.trim(),
  editting: boolean(),
  password: string().when('editting', {
    is: false,
    then: string()
      .max(50, 'Must be less than 50 characters')
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
        'Minimum eight characters, at least one uppercase & lowercase letter, one number and one special character'
      )
      .required('Password is required'),
  }),
  role: string().required('Role is required'),
})

const headerSchema = object().shape({
  logo: string().when('toggleHeader', {
    is: true,
    then: string().required('Logo is required'),
    otherwise: string(),
  }),
  logoName: string().when('toggleHeader', {
    is: true,
    then: string().required('Logo name is required'),
    otherwise: string(),
  }),
  campaignMessage: string().when('toggleHeader', {
    is: true,
    then: string().required('Campaign message is required'),
    otherwise: string(),
  }),
  media: string().when(['imageToggle', 'toggleHeroMedia'], {
    is: {
      imageToggle: true,
      toggleHeroMedia: true,
    },
    then: string().required('Media is required'),
    otherwise: string(),
  }),

  youtubeLink: string().when(['imageToggle', 'toggleHeroMedia'], {
    is: {
      imageToggle: false,
      toggleHeroMedia: true,
    },
    then: string().required('youtube link is required'),
    otherwise: string(),
  }),
})
export const LandingPageValidation = object().shape({
  campaignName: string().required('Campaign name is required'),
  header: headerSchema,
  quote: array().of(
    object().shape({
      content: string(),
      backgroundImage: string(),
      backgroundImageName: string(),
    })
  ),
  bulletPoints: array().of(
    object().shape({
      content: string(),
    })
  ),
  whereWhen: object().when('toggleWhereWhen', {
    is: true,
    then: object().shape({
      eventTitle: string().required('Event title is required'),
      eventDescription: string().required('Event description is required'),
      address: string().required('Address is required'),
      start: date().nullable().required('Start date is required'),
      end: date()
        .nullable()
        .min(ref('start'), 'End date must be later than start date')
        .required('End date is required'),
    }),
  }),
  rsvp: object().when('toggleRsvp', {
    is: true,
    then: object().shape({
      email: string().email('Invalid email').required('RSVP notification address is required'),
      title: string().required('RSVP title is required'),
      option: array().of(string()).min(2, 'At least two options are required'),
    }),
  }),
})
export const AutoRefillValidation = object().shape({
  smsCredit: number()
    .when('autoTopupSMS', {
      is: true,
      then: number().min(20).required(),
      otherwise: number().default(0),
    })
    .default(0),
  mmsCredit: number().when('autoTopupMMS', {
    is: true,
    then: number().min(20).required(),
    otherwise: number(),
  }),
  autoTopupSMS: boolean().default(false),
  autoTopuMMS: boolean().default(false),
  smsThreshold: number()
    .default(0)
    .when('autoTopupSms', {
      is: true,
      then: number()
        .typeError('Please enter a valid credit')
        .required('Required')
        .min(5, 'Value must be greater than or equal to 5')
        .max(200000, 'Value must be less than or equal to 200000'),
      otherwise: number().default(0),
    }),
  mmsThreshold: number()
    .default(0)
    .when('autoTopupMms', {
      is: true,
      then: number()
        .typeError('Please enter a valid credit')
        .required('Required')
        .min(5, 'Value must be greater than or equal to 5')
        .max(200000, 'Value must be less than or equal to 200000'),
      otherwise: number().default(0),
    }),
  // Add validation for other fields as needed
})

const isEmail = (value: any) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) // or use your own

export const LowCreditValidation = object().shape({
  email: string()
    .transform((value) => Array.from(new Set(value.split(';'))).join(';')) // dedupe - optional step
    .required()
    .test(
      'emails',
      'Invalid email address',
      (value: any) => value && value.split(';').every(isEmail)
    )
    .when('alertType', {
      is: (alertType: string[]) => {
        return alertType?.includes('email')
      },
      then: string().required('Please enter email'),
    }),
  mobile: string()
    .matches(
      /^(?:(61))?(?:\((?=.*\)))?(0?[4])?(\d\d(?:[-](?=\d{3})|(?!\d\d[-]?\d[-]))\d\d[-]?\d[-]?\d{3})$/,
      'Invalid mobile number'
    )
    .when('alertType', {
      is: (alertType: string[]) => {
        return alertType?.includes('mobile')
      },
      then: string().required('Please enter mobile number'),
    }),
  smsCredit: number()
    .typeError('Please enter a valid credit')
    .positive('Please enter a positive credit')
    .integer('Please enter an integer')
    .required('Sms credit is required'),
  mmsCredit: number()
    .typeError('Please enter a valid credit')
    .positive('Please enter a positive credit')
    .integer('Please enter an integer')
    .required('Mms credit is required'),
})

export const FrontEndUserAccountSchema = object().shape({
  email: string().email('Wrong email format').required('Email is required'),
  mobile: string()
    .matches(
      /^(?:(61))?(?:\((?=.*\)))?(0?[4])?(\d\d(?:[-](?=\d{3})|(?!\d\d[-]?\d[-]))\d\d[-]?\d[-]?\d{3})$/,
      'Please enter valid number'
    )
    .required('Mobile number is required'),
  name: string()
    .max(25, 'Input exceeds the maximum character length of 25')
    .trim()
    .matches(/^\S/, 'Text field cannot start with a space')
    .required('Full name is required'),
  editting: boolean(),
  password: string().when('editting', {
    is: false,
    then: string()
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
        'Minimum eight characters, at least one uppercase & lowercase letter, one number and one special character'
      )
      .max(50, 'Must be less than 50 characters')
      .required('Password is required'),
  }),
  role: string().required('Role is required'),
})

export const whiteLabelUserSchema = object().shape({
  name: string()
    .max(25, 'Input exceeds the maximum character length of 25')
    .matches(/^\S/, 'Text field cannot start with a space')
    .required('Full name is required')
    .trim('The contact name cannot include leading and trailing spaces'),
  logo: string().required('Logo is required'),
  email: string().email('Wrong email format').required('Email is required'),
  companyName: string()
    .matches(/^\S/, 'Text field cannot start with a space')
    .max(25, 'Input exceeds the maximum character length of 25')
    .required('Company name is required')
    .trim('The contact name cannot include leading and trailing spaces'),
  mobile: string()
    .matches(
      /^(?:(61))?(?:\((?=.*\)))?(0?[4])?(\d\d(?:[-](?=\d{3})|(?!\d\d[-]?\d[-]))\d\d[-]?\d[-]?\d{3})$/,
      'Please enter valid number'
    )
    .required('Mobile number is required'),
  whiteLabelSubdomain: string()
    .matches(/^(?=.{1,32}$)([a-zA-Z0-9]+([a-zA-Z0-9-_]+)*)$/, 'Please enter valid sub-domain')
    .required('Sub Domain is required'),
  password: string().when('editting', {
    is: false,
    then: string()
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
        'Minimum eight characters, at least one uppercase & lowercase letter, one number and one special character'
      )
      .max(50, 'Must be less than 50 characters')
      .required('Password is required'),
  }),
})

export const GlobalSettingValidation = object().shape({
  MIN_PURCHASES_SMS_CERDIT: number()
    .typeError('Please enter a valid number')
    .required('Number is required')
    .positive('Number must be positive')
    .integer('Number must be an integer'),
  MIN_PURCHASES_MMS_CERDIT: number()
    .typeError('Please enter a valid number')
    .required('Number is required')
    .positive('Number must be positive')
    .integer('Number must be an integer'),
  USER_SIGNUP_SMS_CREDIT: number()
    .typeError('Please enter a valid number')
    .required('Number is required')
    .positive('Number must be positive')
    .integer('Number must be an integer'),
  USER_SIGNUP_MMS_CREDIT: number()
    .typeError('Please enter a valid number')
    .required('Number is required')
    .positive('Number must be positive')
    .integer('Number must be an integer'),
  USER_SIGNUP_POPUP_SMS_CREDIT: number()
    .typeError('Please enter a valid number')
    .required('Number is required')
    .positive('Number must be positive')
    .integer('Number must be an integer'),
})

const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([\/\w .-]*)*\/?$/
export const profileDetailsSchema = object().shape({
  firstName: string()
    .matches(/^\S/, 'Text field cannot start with a space')
    .max(25, 'Input exceeds the maximum character length of 25')
    .required('First name is required'),
  lastName: string()
    .matches(/^\S/, 'Text field cannot start with a space')
    .max(25, 'Input exceeds the maximum character length of 25')
    .required('Last name is required'),
  email: string().email('Wrong email format').required('Email is required'),
  companyName: string()
    .max(255, 'Input exceeds the maximum character length of 255')
    .matches(/^\S/, 'Text field cannot start with a space')
    .when('isUserAllow', {
      is: true,
      then: string().required('Company name is required'),
    }),
  companyWebsite: string().when('isUserAllow', {
    is: true,
    then: string()
      .matches(urlRegex, {
        message:
          'The URL is not valid. Please ensure it follows the format www.example.com or http(s)://example.com',
        excludeEmptyString: true,
      })
      .test('valid-domain', 'URL must contain a valid domain (e.g., example.com)', (value: any) => {
        const domainRegex = /([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}/
        return domainRegex.test(value)
      })
      .required('Company website is required'),
  }),
  country: string().when('isUserAllow', {
    is: true,
    then: string().required('Country is required'),
  }),
  language: string().when('isUserAllow', {
    is: true,
    then: string().required('Language is required'),
  }),
  timeZone: string().when('isUserAllow', {
    is: true,
    then: string().required('Time zone is required'),
  }),
  currency: string().when('isUserAllow', {
    is: true,
    then: string().required('Currency is required'),
  }),
  safeSendingStartTime: string().when('safeSendingStatus', {
    is: true, // Condition when safeSending is true
    then: string().required('Start Time is required').nullable(), // Required if true
    otherwise: string().nullable(), // Not required if false
  }),
  safeSendingEndTime: string().when('safeSendingStatus', {
    is: true, // Condition when safeSending is true
    then: string().required('End Time is required').nullable(), // Required if true
    otherwise: string().nullable(), // Not required if false
  }),
})

export const staffprofileDetailsSchema = object().shape({
  name: string()
    .matches(/^\S/, 'Text field cannot start with a space')
    .max(25, 'Input exceeds the maximum character length of 25')
    .required('Full Name is required'),
  mobile: string().required('Contact phone is required'),
  email: string().email('Wrong email format').required('Email is required'),
})

export const emailFormValidationSchema = object().shape({
  newEmail: string()
    .email('Wrong email format')

    .required('Email is required'),
  confirmPassword: string().required('Password is required'),
})

export const networkChangeValidationSchema = object().shape({
  statusPageSubscribtionEmail: string()
    .transform((value) => Array.from(new Set(value.split(';'))).join(';')) // dedupe - optional step
    .required('Email is required')
    .test(
      'emails',
      'Wrong email address',
      (value: any) => value && value.split(';').every(isEmail)
    ),
})

export const passwordFormValidationSchema = object().shape({
  currentPassword: string().required('Current Password is required'),
  newPassword: string()
    .max(50, 'Must be less than 50 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
      'Minimum eight characters, at least one uppercase & lowercase letter, one number and one special character'
    )
    .required('New Password is required'),
  passwordConfirmation: string()
    .required('Confirm Password is required')
    .oneOf([ref('newPassword'), null], 'Passwords must match'),
})

export const forgotPasswordSchema = object().shape({
  email: string()
    .email('Wrong email format')

    .required('Email is required'),
})

export const registrationSchema = object().shape({
  fullName: string()
    .matches(/^\S/, 'Text field cannot start with a space')
    .required('Full Name is required'),
  company: string()
    .matches(/^\S/, 'Text field cannot start with a space')
    .required('Company is required'),
  email: string()
    .email('Wrong email format')

    .required('Email is required'),
  phoneNumber: string().max(11, 'Maximum 11 symbols').required('Phone Number is required'),
  password: string()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/,
      'Minimum eight characters, at least one uppercase & lowercase letter, one number and one special character'
    )
    .max(50, 'Must be less than 50 characters')
    .required('Password is required'),
})

export const loginSchema = object().shape({
  email: string().email('Wrong email format').required('Email is required'),
  password: string().required('Password is required'),
})

export const isMobileValidate = (number: any) => {
  let result = CONTACT_FORMAT_REGEX.test(number)

  return result
}

export const isNumberOnly = (input: string) => {
  var regex = /^[0-9]+$/
  return regex.test(input)
}

export const numberWithSymbol = (input: string) => {
  var regex = /^[0-9,]+$/
  return regex.test(input)
}

export const emailToSmsSchema = object().shape({
  email: string().test({
    name: 'email',
    message: 'Please enter valid comma-separated emails',
    test: (value) => {
      const emailsArray = value?.split(',')?.map((email) => email.trim())
      return (
        !emailsArray ||
        emailsArray.every((key) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(key) || key === '')
      )
    },
  }),
  wildCardDomain: string().test({
    name: 'wildCardDomain',
    message: 'Please enter a valid Company Domain',
    test: (value, context) => {
      const checkWildCard = CompanyEmailValidator?.isCompanyEmail(`test@${value}`)
      const email = context.parent.email ?? ''
      if (
        /^(?!^www)[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/.test(
          value as string
        )
      ) {
        if (checkWildCard || email === '') {
          return true
        } else {
          return false
        }
      } else {
        if (email === '') {
          return false
        }
      }

      return true
    },
  }),
})

export const BillingAddressSchema = object().shape({
  billingEmail: string().email('Wrong email format').required('Billing Email is required'),
  billingPhoneNumber: string()
    .matches(
      /^(?:(61))?(?:\((?=.*\)))?(0?[4])?(\d\d(?:[-](?=\d{3})|(?!\d\d[-]?\d[-]))\d\d[-]?\d[-]?\d{3})$/,
      'Please enter valid number'
    )
    .required('Billing Phone Number is required'),
})
